import {
  animate,
  group,
  keyframes,
  query,
  sequence,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

const ANIMATION_DURATION = '400ms';
const ANIMATION_NAVIGATION_BUTTON_DURATION = '300ms';
const ANIMATION_DELAY = '250ms';
const ANIMATION_DURATION_TOGGLE_ICON = '50ms';
const ANIMATION_DELAY_TOGGLE_ICON = '700ms';

const TRANSITION_CLOSED_TO_OPENED = 'closed => opened';
const TRANSITION_OPENED_TO_CLOSED = 'opened => closed';

const EASE_IN_OUT_BACK = 'cubic-bezier(0.68, -0.55, 0.265, 1.55)';

export const sidebarAnimation = trigger('sidebarAnimation', [
  state('closed', style({ width: '80px' })),
  state('opened', style({ width: '296px' })),

  transition(TRANSITION_CLOSED_TO_OPENED, [
    group([
      animate(
        `${ANIMATION_DURATION} ${ANIMATION_DELAY} ${EASE_IN_OUT_BACK}`,
        keyframes([
          style({ width: '80px', offset: 0 }),
          style({ width: '296px', offset: 1 }),
        ]),
      ),
      query('.sidebar-toggle-icon', [
        style({ opacity: 0 }),
        animate(
          `${ANIMATION_DURATION_TOGGLE_ICON} ${ANIMATION_DELAY_TOGGLE_ICON} ease-in-out`,
          keyframes([
            style({ opacity: 0, offset: 0 }),
            style({ opacity: 1, offset: 1 }),
          ]),
        ),
      ]),
      query('.navigation-button', [
        style({ minHeight: '32px' }),
        animate(
          `${ANIMATION_NAVIGATION_BUTTON_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ minHeight: '32px', offset: 0 }),
            style({ minHeight: '56px', offset: 1 }),
          ]),
        ),
      ]),
      query('.thread-listing', [
        style({ opacity: 0 }),
        animate(
          `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ opacity: 0, offset: 0 }),
            style({ opacity: 1, offset: 1 }),
          ]),
        ),
      ]),
      query('.bottom-section', [
        style({ opacity: 0 }),
        animate(
          `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ opacity: 0, offset: 0 }),
            style({ opacity: 1, offset: 1 }),
          ]),
        ),
      ]),
    ]),
  ]),

  transition(TRANSITION_OPENED_TO_CLOSED, [
    group([
      animate(
        `${ANIMATION_DURATION} ${ANIMATION_DELAY} ${EASE_IN_OUT_BACK}`,
        keyframes([
          style({ width: '296px', offset: 0 }),
          style({ width: '80px', offset: 1 }),
        ]),
      ),
      query('.sidebar-toggle-icon', [
        animate(
          `${ANIMATION_DURATION_TOGGLE_ICON} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ opacity: 1, offset: 0 }),
            style({ opacity: 0, offset: 1 }),
          ]),
        ),
      ]),
      query('.navigation-button', [
        style({ minHeight: '56px' }),
        animate(
          `${ANIMATION_NAVIGATION_BUTTON_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ minHeight: '56px', offset: 0 }),
            style({ minHeight: '32px', offset: 1 }),
          ]),
        ),
      ]),
      query('.thread-listing', [
        style({ opacity: 1 }),
        animate(
          `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ opacity: 1, offset: 0 }),
            style({ opacity: 0, offset: 1 }),
          ]),
        ),
      ]),
      query('.bottom-section', [
        style({ opacity: 1 }),
        animate(
          `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
          keyframes([
            style({ opacity: 1, offset: 0 }),
            style({ opacity: 0, offset: 1 }),
          ]),
        ),
      ]),
    ]),
  ]),
]);

export const sidebarToggleIconAnimation = trigger(
  'sidebarToggleIconAnimation',
  [
    state(
      'closed',
      style({
        opacity: 0,
      }),
    ),
    state(
      'opened',
      style({
        opacity: 1,
      }),
    ),

    transition(TRANSITION_CLOSED_TO_OPENED, [
      animate(
        `${ANIMATION_DURATION_TOGGLE_ICON} ${ANIMATION_DELAY_TOGGLE_ICON} ease-in-out`,
        keyframes([
          style({ opacity: 0, offset: 0 }),
          style({ opacity: 1, offset: 1 }),
        ]),
      ),
    ]),
    transition(TRANSITION_OPENED_TO_CLOSED, [
      animate(
        `${ANIMATION_DURATION_TOGGLE_ICON} ${ANIMATION_DELAY_TOGGLE_ICON} ease-in-out`,
        keyframes([
          style({ opacity: 1, offset: 0 }),
          style({ opacity: 0, offset: 1 }),
        ]),
      ),
    ]),
  ],
);

export const headerToggleIconAnimation = trigger('headerToggleIconAnimation', [
  state(
    'opened',
    style({
      opacity: 0,
    }),
  ),
  state(
    'closed',
    style({
      opacity: 1,
    }),
  ),

  transition(TRANSITION_CLOSED_TO_OPENED, [
    animate(
      `${ANIMATION_DURATION_TOGGLE_ICON} ease-in-out`,
      keyframes([
        style({ opacity: 1, offset: 0 }),
        style({ opacity: 0, offset: 1 }),
      ]),
    ),
  ]),
  transition(TRANSITION_OPENED_TO_CLOSED, [
    animate(
      `${ANIMATION_DURATION_TOGGLE_ICON} ${ANIMATION_DELAY_TOGGLE_ICON}  ease-in-out`,
      keyframes([
        style({ opacity: 0, offset: 0 }),
        style({ opacity: 1, offset: 1 }),
      ]),
    ),
  ]),
]);

export const navigationButtonAnimation = trigger('navigationButtonAnimation', [
  // State when sidebar is closed
  state(
    'closed',
    style({
      minHeight: '32px',
    }),
  ),

  // State when sidebar is opened
  state(
    'opened',
    style({
      minHeight: '56px',
    }),
  ),

  // // Transition from closed to opened
  transition(TRANSITION_CLOSED_TO_OPENED, [
    // Start with closed state
    style({
      minHeight: '32px',
    }),
    // Animate to opened state with delay
    animate(
      `${ANIMATION_DURATION} ease-in-out`,
      keyframes([
        style({ minHeight: '32px', offset: 0 }),
        style({ minHeight: '56px', offset: 1 }),
      ]),
    ),
  ]),

  // Transition from opened to closed
  transition(TRANSITION_OPENED_TO_CLOSED, [
    // Start with opened state
    style({
      // maxWidth: '256px',
      minHeight: '56px',
    }),
    // Animate to closed state with delay
    animate(
      `${ANIMATION_DURATION} ease-in-out`,
      keyframes([
        style({ minHeight: '56px', offset: 0 }),
        style({ minHeight: '32px', offset: 1 }),
      ]),
    ),
  ]),
]);

export const threadListingAnimation = trigger('threadListingAnimation', [
  state(
    'opened',
    style({
      opacity: 1,
    }),
  ),
  state(
    'closed',
    style({
      opacity: 0,
    }),
  ),

  transition(TRANSITION_CLOSED_TO_OPENED, [
    animate(
      `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
      keyframes([
        style({ opacity: 0, offset: 0 }),
        style({ opacity: 1, offset: 1 }),
      ]),
    ),
  ]),
  transition(TRANSITION_OPENED_TO_CLOSED, [
    animate(
      `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
      keyframes([
        style({ opacity: 1, offset: 0 }),
        style({ opacity: 0, offset: 0.2 }),
        style({ opacity: 0, offset: 1 }),
      ]),
    ),
  ]),
]);

export const userInfoAnimation = trigger('userInfoAnimation', [
  state(
    'opened',
    style({
      display: 'flex',
    }),
  ),
  state(
    'closed',
    style({
      display: 'none',
    }),
  ),

  transition('closed => opened', [
    animate(
      `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
      style({
        display: 'block',
      }),
    ),
  ]),
  transition('opened => closed', [
    sequence([
      animate(
        `${ANIMATION_DURATION} ${ANIMATION_DELAY} ease-in-out`,
        style({
          opacity: 0,
        }),
      ),
      animate(
        '0ms',
        style({
          display: 'none',
        }),
      ),
    ]),
  ]),
]);
